/* ═══════════════════════════════════════════════════════════════════════
   tws-search.js
   GENERATED by ui_kits/website/search-src/build-theme.py — do not hand-edit.
   Source of truth: search-src/search-core.js + theme-search.js
   ═══════════════════════════════════════════════════════════════════════ */
/* ══════════════════════════════════════════════════════════════════════════
   TWS SEARCH ENGINE — shared by BOTH design versions.

   Ships as one file so version A and version B are a pure design difference:
   identical results, identical ranking, identical typo handling. Whichever
   design is approved, this is the file that becomes assets/tws-search.js.

   What it fixes versus the search live today:
     1. Shopify's /search only returns PRODUCTS, PAGES and ARTICLES. Authors
        and Featured Writings are metaobjects, which are not in Shopify's
        search index at all — 77 pages of our best content were unfindable.
     2. No typo tolerance. "kamran ahmed" returned nothing; the author is
        spelled Ahmad.
     3. No vocabulary. A reader types "poems", "novel", "prize", "buy" —
        the catalogue says "poetry", "fiction", "award", "shop".
     4. Product cards printed product.price, which is the LOWEST variant =
        the eBook. See snippets/tws-price-shown.liquid — same rule here.

   API
     TWSSearch.init(rows)        rows = [type, handle, title, subtitle,
                                         keywords, excerpt, image, price,
                                         extra, url]
     TWSSearch.query(q, opts)    -> {q, total, counts, all, groups, didYouMean}
     TWSSearch.mark(text, q)     -> HTML with <mark> around the matched run
     TWSSearch.TYPES             display metadata, per type key
   ══════════════════════════════════════════════════════════════════════════ */
window.TWSSearch = (function () {
  'use strict';

  /* ---- 1. Type metadata --------------------------------------------------
     `boost` is a small nudge, not a ranking: it only settles ties. An author
     outranks their own book on an exact name match because someone typing a
     person's name usually wants the person. */
  var TYPES = {
    p: { key: 'p', label: 'Book',             plural: 'Books',             boost: 8  },
    a: { key: 'a', label: 'Author',           plural: 'Authors',           boost: 30 },
    w: { key: 'w', label: 'Featured writing', plural: 'Featured writings', boost: 12 },
    r: { key: 'r', label: 'Article',          plural: 'Reading',           boost: 6  },
    g: { key: 'g', label: 'Page',             plural: 'Pages',             boost: 10 },
    c: { key: 'c', label: 'Collection',       plural: 'Collections',       boost: 14 }
  };
  var ORDER = ['p', 'a', 'w', 'r', 'g', 'c'];

  /* ---- 2. Vocabulary -----------------------------------------------------
     Reader's word -> our word. Expansions score at 60% so a literal match
     always wins over a synonym match. */
  var SYN = {
    poem: ['poetry'], poems: ['poetry'], poetic: ['poetry'], verse: ['poetry'],
    nazm: ['poetry'], ghazal: ['poetry'], shayari: ['poetry'],
    novel: ['fiction'], novels: ['fiction'], story: ['fiction'], stories: ['fiction'],
    fictional: ['fiction'], short: ['fiction'],
    nonfiction: ['non-fiction'], essay: ['non-fiction'], essays: ['non-fiction'],
    memoir: ['non-fiction'], biography: ['non-fiction'], selfhelp: ['non-fiction'],
    kids: ['children'], child: ['children'], childrens: ['children'], kid: ['children'],
    prize: ['award'], competition: ['award'], contest: ['award'], winner: ['award'],
    winners: ['award'], lea: ['award'], excellence: ['award'],
    submit: ['submission'], submitting: ['submission'], manuscript: ['submission'],
    publish: ['publishing'], publisher: ['publishing'], selfpublish: ['publishing'],
    mag: ['magazine'], issue: ['magazine'], journal: ['magazine'], issues: ['magazine'],
    anthology: ['antho'], anthologies: ['antho'],
    buy: ['shop'], order: ['shop'], purchase: ['shop'], price: ['shop'], cost: ['shop'],
    ebook: ['digital'], kindle: ['digital'], pdf: ['digital'], epub: ['digital'],
    hardback: ['hardcover'], softcover: ['paperback'], print: ['paperback'],
    delivery: ['shipping'], returns: ['refund'], refunds: ['refund'],
    writer: ['author'], writers: ['author'], poet: ['author'], novelist: ['author'],
    blog: ['article'], guide: ['article'], advice: ['article'], tips: ['article'],
    faqs: ['faq'], help: ['faq'], question: ['faq'], questions: ['faq'],
    contact: ['contact email'], email: ['contact'], phone: ['contact']
  };

  /* SOFT words still add to the score when they happen to match — they just
     never eliminate a record on their own. Two families live here:
       · grammar   — "the shape of longing" must not fail on a missing "of"
       · intent    — people type whole questions. "how do i submit my
                     manuscript" has exactly one word worth requiring.
     Being generous here is safe precisely because a soft word can only ever
     help a record's rank, never disqualify one. */
  var SOFT = {};
  ('the a an of and or in on to for by with is it at from book books ' +
   'how do does did what whats where when which who why can could should would will ' +
   'i my me we our you your us there their this that these those be was were are am been ' +
   'want need looking look find get got have has about please tell show give ' +
   'buy order purchase price cost read download online more most very just only also ' +
   'if but not no yes any all some'
  ).split(' ').forEach(function (w) { SOFT[w] = 1; });

  /* ---- 3. Text helpers --------------------------------------------------- */
  function norm(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')   // é -> e
      .replace(/['’`]/g, '')                              // don't -> dont
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function wordsOf(s) { var n = norm(s); return n ? n.split(' ') : []; }

  /* Bounded Levenshtein — bails out as soon as the whole row exceeds `max`,
     so a 500-record sweep stays cheap. */
  function lev(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev = new Array(lb + 1), cur = new Array(lb + 1), i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur[0] = i;
      var best = cur[0];
      for (j = 1; j <= lb; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1,
                          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      var t = prev; prev = cur; cur = t;
    }
    return prev[lb];
  }

  /* ---- 4. Index ---------------------------------------------------------- */
  var RECS = [];
  var VOCAB = [];   // every distinct title/author word — powers "did you mean"

  function init(rows, append) {
    if (!append) { RECS = []; VOCAB = []; }
    var base = RECS.length;
    var added = rows.map(function (row, i) {
      i += base;
      var r = {
        i: i, type: row[0], handle: row[1], title: row[2], subtitle: row[3],
        keywords: row[4], excerpt: row[5], img: row[6], price: row[7],
        extra: row[8], url: row[9]
      };
      r._t  = norm(r.title);
      r._tw = r._t ? r._t.split(' ') : [];
      r._s  = norm(r.subtitle);
      r._sw = r._s ? r._s.split(' ') : [];
      r._kw = wordsOf(r.keywords);
      r._x  = norm(r.excerpt);
      r._h  = norm(r.handle);
      return r;
    });
    RECS = RECS.concat(added);
    var seen = {};
    VOCAB = [];
    RECS.forEach(function (r) {
      r._tw.concat(r._sw).forEach(function (w) {
        if (w.length > 3 && !seen[w]) { seen[w] = 1; VOCAB.push(w); }
      });
    });
    return RECS.length;
  }

  /* ---- 5. Scoring one record against one query term ----------------------
     `fuzzy` is only ever true for the word the reader literally typed — never
     for a synonym or a plural we invented. Inventing a word and then allowing
     it two edits is how "prize" ends up matching "Before The Ink Dries"
     (prizes → dries is two edits). */
  function termScore(r, w, fuzzy) {
    var best = 0, i, word, d;

    for (i = 0; i < r._tw.length; i++) {
      word = r._tw[i];
      if (word === w) { best = Math.max(best, i === 0 ? 120 : 100); }
      else if (word.indexOf(w) === 0) { best = Math.max(best, i === 0 ? 86 : 72); }
      else if (w.length >= 4 && word.indexOf(w) > 0) { best = Math.max(best, 42); }
    }
    if (best >= 100) return best;

    for (i = 0; i < r._sw.length; i++) {
      word = r._sw[i];
      if (word === w) best = Math.max(best, 92);
      else if (word.indexOf(w) === 0) best = Math.max(best, 64);
      else if (w.length >= 4 && word.indexOf(w) > 0) best = Math.max(best, 34);
    }

    for (i = 0; i < r._kw.length; i++) {
      word = r._kw[i];
      if (word === w) best = Math.max(best, 48);
      else if (word.indexOf(w) === 0) best = Math.max(best, 30);
    }

    if (best < 30 && w.length >= 3 && r._h.indexOf(w) >= 0) best = Math.max(best, 26);
    if (best < 20 && w.length >= 4 && r._x.indexOf(w) >= 0) best = Math.max(best, 16);

    /* Typo tolerance — only when nothing matched cleanly, only on words long
       enough that one edit isn't simply a different word, and only within a
       budget that scales with length: one edit up to 7 letters, two from 8.
       A typo almost never lands on the first letter, and requiring it to hold
       is what separates "ahmed"→"ahmad" from "prize"→"dries". */
    if (fuzzy && best === 0 && w.length >= 4) {
      var max = w.length >= 8 ? 2 : 1;
      var pool = r._tw.concat(r._sw, r._kw);
      for (i = 0; i < pool.length; i++) {
        word = pool[i];
        if (word.length < 3 || word.charAt(0) !== w.charAt(0)) continue;
        d = lev(w, word, max);
        if (d <= max) best = Math.max(best, 38 - 12 * d);
      }
    }
    return best;
  }

  /* Expand one typed word into the variants we will accept. The literal word
     is the only one allowed to match fuzzily (`f`). */
  function variants(w) {
    var out = [{ w: w, m: 1, f: true }];
    var syn = SYN[w];
    if (syn) syn.forEach(function (s) { out.push({ w: s, m: 0.6, f: false }); });
    /* plural / singular, cheaply */
    if (w.length > 3 && w.slice(-1) === 's') out.push({ w: w.slice(0, -1), m: 0.9, f: false });
    else if (w.length > 2) out.push({ w: w + 's', m: 0.9, f: false });
    return out;
  }

  /* ---- 6. Query ---------------------------------------------------------- */
  function query(q, opts) {
    opts = opts || {};
    var nq = norm(q);
    var raw = nq ? nq.split(' ') : [];
    var terms = raw.filter(function (w) { return w.length > 0; }).map(function (w) {
      return { w: w, vars: variants(w), soft: !!SOFT[w] };
    });
    var hardCount = terms.filter(function (t) { return !t.soft; }).length;
    /* A query made only of soft words ("how do i") still has to search on
       something, so in that case every word counts. */
    if (!hardCount) { terms.forEach(function (t) { t.soft = false; }); hardCount = terms.length; }

    var strict = [], loose = [];
    if (terms.length) {
      for (var n = 0; n < RECS.length; n++) {
        var r = RECS[n], total = 0, hardHit = 0, hardMiss = 0, anyHit = 0;
        for (var t = 0; t < terms.length; t++) {
          var term = terms[t], s = 0;
          for (var v = 0; v < term.vars.length; v++) {
            var vr = term.vars[v];
            s = Math.max(s, termScore(r, vr.w, vr.f) * vr.m);
          }
          /* A soft word may colour the ranking, never dominate it: "buy
             poetry" must not put a piece called "My mother buys vegetables…"
             above the poetry. */
          if (s && term.soft) s *= 0.25;
          if (s) { total += s; anyHit++; if (!term.soft) hardHit++; }
          else if (!term.soft) hardMiss++;
        }
        if (!anyHit) continue;

        /* Whole-phrase bonuses — "the song of our blood" should beat a record
           that merely contains all five words scattered about. */
        if (terms.length > 1) {
          if (r._t.indexOf(nq) === 0) total += 160;
          else if (r._t.indexOf(nq) > 0) total += 90;
          else if (r._s.indexOf(nq) >= 0) total += 70;
        }
        if (r._t === nq) total += 200;
        if (r._s === nq) total += 120;

        total += TYPES[r.type].boost;
        /* Newer titles edge out older ones on an otherwise level score. */
        if (r.type === 'p' && r.extra) total += Math.min(6, (parseInt(r.extra.slice(0, 4), 10) - 2020) * 0.8);

        if (!hardMiss) strict.push({ rec: r, score: total });
        /* Partial pass: only consulted when nothing matched every word, and
           only for queries long enough that demanding all of them is unfair.
           Coverage scales the score so a 3-of-4 beats a 2-of-4. */
        else if (hardCount >= 3 && hardHit >= Math.ceil(hardCount / 2)) {
          loose.push({ rec: r, score: total * (hardHit / hardCount) });
        }
      }
    }
    var out = strict.length ? strict : loose;
    var partial = !strict.length && loose.length > 0;
    out.sort(function (x, y) {
      if (y.score !== x.score) return y.score - x.score;
      var oi = ORDER.indexOf(x.rec.type) - ORDER.indexOf(y.rec.type);
      if (oi) return oi;
      return x.rec.title.localeCompare(y.rec.title);
    });

    var counts = { all: out.length };
    ORDER.forEach(function (k) { counts[k] = 0; });
    var groups = {};
    ORDER.forEach(function (k) { groups[k] = []; });
    out.forEach(function (h) { counts[h.rec.type]++; groups[h.rec.type].push(h.rec); });

    return {
      q: q, nq: nq, terms: raw, total: out.length, counts: counts, groups: groups,
      partial: partial,
      all: out.map(function (h) { return h.rec; }),
      didYouMean: out.length ? null : suggestSpelling(raw)
    };
  }

  /* ---- 7. "Did you mean" ------------------------------------------------- */
  function suggestSpelling(terms) {
    if (!terms.length) return null;
    var fixed = [], changed = false;
    terms.forEach(function (w) {
      if (w.length < 4) { fixed.push(w); return; }
      var best = null, bestD = 3;
      for (var i = 0; i < VOCAB.length; i++) {
        var d = lev(w, VOCAB[i], 2);
        if (d < bestD) { bestD = d; best = VOCAB[i]; if (d === 1) break; }
      }
      if (best) { fixed.push(best); changed = true; } else fixed.push(w);
    });
    return changed ? fixed.join(' ') : null;
  }

  /* ---- 8. Highlighting --------------------------------------------------- */
  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* Marks each typed word wherever it appears, on the ORIGINAL text (so
     capitals and punctuation survive). Longest words first so "poetry" wins
     over "poe" and we never nest a mark inside a mark. */
  function mark(text, q) {
    var t = esc(text || '');
    var all = norm(q).split(' ').filter(function (w) { return w.length > 1; });
    /* Highlighting "how" and "do" all over a paragraph is noise, not help —
       mark the words the reader is actually hunting for. */
    var ws = all.filter(function (w) { return !SOFT[w]; });
    if (!ws.length) ws = all;
    ws.sort(function (a, b) { return b.length - a.length; });
    if (!ws.length) return t;
    var re = new RegExp('(' + ws.map(function (w) {
      return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|') + ')', 'ig');
    var parts = t.split(/(<[^>]*>)/);   // never touch entity-free tags
    return parts.map(function (p, i) {
      return i % 2 ? p : p.replace(re, '<mark>$1</mark>');
    }).join('');
  }

  /* ---- 9. Zero-state suggestions ----------------------------------------- */
  function sample(type, n) {
    var pool = RECS.filter(function (r) { return r.type === type; });
    return pool.slice(0, n);
  }

  return {
    init: init, query: query, mark: mark, esc: esc, norm: norm, sample: sample,
    TYPES: TYPES, ORDER: ORDER,
    get records() { return RECS; }
  };
})();

/* ══════════════════════════════════════════════════════════════════════════
   TWS SEARCH — the theme's UI layer. "The Shelf" (version B), approved
   21 Aug 2026. Pairs with search-core.js above, which is the identical engine
   the local previews run, and with assets/tws-search.css.

   TWO SURFACES, ONE SCRIPT:
     · the panel — rendered site-wide from snippets/tws-search-panel.liquid,
       which the header includes. Opens from the header's search icons.
     · the results page — sections/tws-search-results.liquid, on /search only.
   Everything below guards for the results page being absent.

   WHERE THE DATA COMES FROM. Nothing is inlined into the page: the header
   renders on every page and ~200 KB of catalogue JSON site-wide would be
   indefensible. Instead the index is pulled through the Section Rendering API
   the first time someone actually opens search, and kept in sessionStorage for
   the rest of the visit. Two sections, three requests at most:
       /?section_id=tws-search-index          (authors, writings, articles, …)
       /?section_id=tws-search-books&page=1   (paginate caps at 250)
       /?section_id=tws-search-books&page=2
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var S = window.TWSSearch;
  var $ = function (id) { return document.getElementById(id); };

  var panel = $('twsSearchPanel');
  if (!panel || !S) return;                 /* header not on this page */

  var scrim    = $('twsSearchScrim');
  var pField   = $('twsSearchField');
  var pInput   = $('twsSearchInput');
  var pMain    = $('twsSearchMain');
  var pSide    = $('twsSearchSide');
  var pAll     = $('twsSearchAll');

  /* the results page — absent everywhere except /search */
  var resultsRoot = $('twsSearchResults');
  var pageInput   = $('twsSearchPageInput');
  var pageField   = $('twsSearchPageField');

  var CFG = window.TWSSearchConfig || {};
  var ROUTE = CFG.searchUrl || '/search';

  /* ---- money ------------------------------------------------------------
     The theme hands us the shop's own format string so this cannot drift from
     the rest of the site if the currency display ever changes. */
  function money(n) {
    var s = Number(n).toLocaleString('en-US');
    return (CFG.moneyPrefix || 'Rs ') + s + (CFG.moneySuffix || '');
  }

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                'August', 'September', 'October', 'November', 'December'];
  function niceDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    return m ? (+m[3]) + ' ' + MONTHS[+m[2] - 1] + ' ' + m[1] : (iso || '');
  }

  function kindOf(r) {
    if (r.type !== 'p') return S.TYPES[r.type].label;
    var k = ' ' + r.keywords + ' ';
    if (k.indexOf(' magazine ') >= 0) return 'Magazine';
    if (k.indexOf(' antho ') >= 0) return 'Anthology';
    if (k.indexOf(' bundle ') >= 0) return 'Bundle';
    if (k.indexOf(' bestseller ') >= 0) return 'Bestseller';
    return 'Book';
  }

  /* ---- recent searches --------------------------------------------------- */
  var RECENT_KEY = 'tws-recent-searches';
  function recent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function remember(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    var l = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    l.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 6))); } catch (e) {}
  }

  var POPULAR = (CFG.popular || 'Poetry|Anthologies|Submit a manuscript|Literary Excellence Award|Children’s books').split('|');
  var QUICK = CFG.quick || [];

  /* ══ DATA ══════════════════════════════════════════════════════════════ */
  var CACHE_KEY = 'tws-search-index-v1';
  var loaded = false, loading = null;

  function readSection(url, id) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error(url + ' → ' + r.status);
        return r.text();
      })
      .then(function (html) {
        /* The Section Rendering API returns the section's markup, so pull the
           JSON out of it rather than trusting the whole body to be JSON. */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById(id);
        if (!el) throw new Error('no #' + id + ' in ' + url);
        return JSON.parse(el.textContent);
      });
  }

  function fetchAll() {
    var rows = [];
    return readSection('?section_id=tws-search-index', 'twsSearchIndex')
      .then(function (d) {
        rows = rows.concat(d.rows || []);
        return readSection('?section_id=tws-search-books&page=1', 'twsSearchBooks');
      })
      .then(function (d) {
        rows = rows.concat(d.rows || []);
        var more = [];
        for (var p = 2; p <= (d.pages || 1); p++) {
          more.push(readSection('?section_id=tws-search-books&page=' + p, 'twsSearchBooks'));
        }
        return Promise.all(more);
      })
      .then(function (pages) {
        pages.forEach(function (d) { rows = rows.concat(d.rows || []); });
        return rows;
      });
  }

  function load() {
    if (loaded) return Promise.resolve();
    if (loading) return loading;

    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) {}
    if (cached && cached.length) {
      S.init(cached);
      loaded = true;
      return Promise.resolve();
    }

    loading = fetchAll().then(function (rows) {
      S.init(rows);
      loaded = true;
      loading = null;
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(rows)); } catch (e) {}
    }).catch(function (err) {
      loading = null;
      /* A search that cannot load its index must say so and offer the old
         route out, not sit there looking broken. */
      if (window.console) console.warn('[tws-search]', err);
      throw err;
    });
    return loading;
  }

  function loadingHTML(msg) {
    return '<div class="twsq-none"><span class="twsq-eyebrow">One moment</span>' +
           '<h3>' + (msg || 'Gathering the shelves&hellip;') + '</h3></div>';
  }
  function failHTML(q) {
    return '<div class="twsq-none"><span class="twsq-eyebrow">Search unavailable</span>' +
      '<h3>We couldn&rsquo;t load the catalogue just now</h3>' +
      '<p>Please try again, or <a href="' + ROUTE + '?q=' + encodeURIComponent(q || '') +
      '&amp;options%5Bprefix%5D=last">use the basic search</a>.</p></div>';
  }

  /* ══ CARD RENDERERS ════════════════════════════════════════════════════ */
  function bookCard(r, q) {
    var kind = kindOf(r);
    return '<a class="twsq-card" href="' + r.url + '">' +
      '<span class="cov">' + (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="260" height="390">' : '') +
      (kind !== 'Book' ? '<span class="rib">' + kind + '</span>' : '') + '</span>' +
      '<span class="t">' + S.mark(r.title, q) + '</span>' +
      '<span class="a">' + S.mark(r.subtitle, q) + '</span>' +
      '<span class="p">' + money(r.price) + '</span></a>';
  }
  function initials(name) {
    return (name || '?').split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('');
  }
  function authorCard(r, q) {
    return '<a class="twsq-acard" href="' + r.url + '">' +
      (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="76" height="76">'
             : '<span class="mono">' + S.esc(initials(r.title)) + '</span>') +
      '<span><span class="n">' + S.mark(r.title, q) + '</span>' +
      (r.subtitle ? '<span class="b">' + S.mark(r.subtitle, q) + '</span>' : '') +
      (r.excerpt ? '<span class="x">' + S.mark(r.excerpt, q) + '</span>' : '') + '</span></a>';
  }
  function writingTile(r, q) {
    return '<a class="twsq-tile" href="' + r.url + '">' +
      '<span class="art">' + (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="500" height="375">' : '') + '</span>' +
      '<span class="in">' + (r.extra ? '<span class="g">' + S.esc(r.extra) + '</span>' : '') +
      '<span class="t">' + S.mark(r.title, q) + '</span>' +
      '<span class="a">' + S.mark(r.subtitle, q) + '</span>' +
      (r.excerpt ? '<span class="x">' + S.mark(r.excerpt, q) + '</span>' : '') + '</span></a>';
  }
  function longRow(r, q) {
    var glyph = r.type === 'g' ? '§' : r.type === 'c' ? '¶' : r.title.charAt(0);
    var th = r.img ? '<span class="th"><img src="' + r.img + '" alt="" loading="lazy" width="264" height="168"></span>'
                   : '<span class="th mono">' + S.esc(glyph) + '</span>';
    var meta = r.type === 'r'
      ? 'Publishing Insights' + (r.extra ? ' &middot; ' + niceDate(r.extra) : '')
      : r.type === 'c' ? S.esc(r.subtitle) : 'On this site';
    return '<a class="twsq-rrow" href="' + r.url + '">' + th +
      '<span><span class="t">' + S.mark(r.title, q) + '</span>' +
      '<span class="m">' + meta + '</span>' +
      (r.excerpt ? '<span class="x">' + S.mark(r.excerpt, q) + '</span>' : '') + '</span>' +
      '<span class="go">&rarr;</span></a>';
  }

  /* ══ 1. PANEL ══════════════════════════════════════════════════════════ */
  var cursor = -1;

  function sideHTML(res, q) {
    var html = '';
    if (res && res.total) {
      var seen = {}, sugg = [];
      res.all.forEach(function (r) {
        [r.title, r.subtitle].forEach(function (t) {
          var k = (t || '').toLowerCase();
          if (!k || seen[k] || sugg.length >= 6) return;
          if (k.indexOf(S.norm(q)) < 0) return;
          seen[k] = 1; sugg.push(t);
        });
      });
      if (sugg.length) {
        html += '<h5 class="twsq-h5">Suggestions</h5><div class="twsq-sugg">' +
          sugg.map(function (t) {
            return '<button type="button" data-q="' + S.esc(t) + '"><span class="ic">&#8599;</span>' +
                   S.mark(t, q) + '</button>';
          }).join('') + '</div>';
      }
      html += '<h5 class="twsq-h5' + (html ? ' mt' : '') + '">Found in</h5><div class="twsq-quick">' +
        S.ORDER.filter(function (t) { return res.counts[t]; }).map(function (t) {
          return '<a href="' + ROUTE + '?q=' + encodeURIComponent(q) + '&type=' + t + '" data-tab="' + t + '">' +
                 S.TYPES[t].plural + '<span>' + res.counts[t] + '</span></a>';
        }).join('') + '</div>';
    } else {
      var rec = recent();
      if (rec.length) {
        html += '<h5 class="twsq-h5">Recent</h5><div class="twsq-sugg">' +
          rec.map(function (t) {
            return '<button type="button" data-q="' + S.esc(t) + '"><span class="ic">&#8635;</span>' +
                   S.esc(t) + '</button>';
          }).join('') + '</div>';
      }
      html += '<h5 class="twsq-h5' + (html ? ' mt' : '') + '">Popular</h5><div class="twsq-sugg">' +
        POPULAR.map(function (t) {
          return '<button type="button" data-q="' + S.esc(t) + '"><span class="ic">&#8599;</span>' +
                 S.esc(t) + '</button>';
        }).join('') + '</div>';
    }
    if (QUICK.length) {
      html += '<h5 class="twsq-h5 mt">Quick links</h5><div class="twsq-quick">' +
        QUICK.map(function (l) { return '<a href="' + l[1] + '">' + S.esc(l[0]) + '<span>&rarr;</span></a>'; }).join('') +
        '</div>';
    }
    return html;
  }

  function panelRender(q) {
    cursor = -1;
    var res = q.trim() ? S.query(q) : null;
    pSide.innerHTML = sideHTML(res, q);
    pInput.setAttribute('aria-expanded', res ? 'true' : 'false');

    if (!res) {
      var picks = S.sample('p', 4);
      pMain.innerHTML = picks.length
        ? '<div class="twsq-sec"><div class="twsq-sechead"><h4>Start with a shelf</h4>' +
          '<a href="' + (CFG.shopUrl || '/collections/shop') + '">All titles &rarr;</a></div>' +
          '<div class="twsq-mini">' + picks.map(function (r) {
            return '<a class="card" href="' + r.url + '"><span class="cov">' +
              (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="200" height="300">' : '') + '</span>' +
              '<span class="t">' + S.esc(r.title) + '</span>' +
              '<span class="m">' + S.esc(r.subtitle) + '</span>' +
              '<span class="p">' + money(r.price) + '</span></a>';
          }).join('') + '</div></div>'
        : loadingHTML();
      pAll.textContent = 'Browse all titles →';
      return;
    }

    if (!res.total) {
      pMain.innerHTML = '<div class="twsq-none"><span class="twsq-eyebrow">No matches</span>' +
        '<h3>Nothing found for <em>' + S.esc(q) + '</em></h3>' +
        (res.didYouMean ? '<p>Did you mean <button class="twsq-chip" type="button" data-q="' +
          S.esc(res.didYouMean) + '">' + S.esc(res.didYouMean) + '</button>?</p>' : '') +
        '<p>Try a title, an author, or a genre.</p>' +
        '<div class="twsq-chips">' + POPULAR.slice(0, 4).map(function (p) {
          return '<button class="twsq-chip" type="button" data-q="' + S.esc(p) + '">' + S.esc(p) + '</button>';
        }).join('') + '</div></div>';
      pAll.textContent = 'See all results →';
      return;
    }

    var html = '';
    var top = res.all[0];
    html += '<a class="twsq-top" href="' + top.url + '">' +
      '<span class="cov' + (top.type === 'a' ? ' round' : '') + '">' +
      (top.img ? '<img src="' + top.img + '" alt="" loading="lazy" width="128" height="180">' : '') + '</span>' +
      '<span><span class="lab">Top match &middot; ' + kindOf(top) + '</span>' +
      '<span class="t">' + S.mark(top.title, q) + '</span>' +
      '<span class="m">' + S.mark(top.subtitle || '', q) +
      (top.type === 'p' ? ' &middot; ' + money(top.price) : '') + '</span></span>' +
      '<span class="go">View &rarr;</span></a>';

    var books = res.groups.p.filter(function (r) { return r !== top; });
    if (books.length) {
      html += '<div class="twsq-sec"><div class="twsq-sechead"><h4>Books</h4>' +
        '<button type="button" data-tab="p">See all ' + res.counts.p + ' &rarr;</button></div>' +
        '<div class="twsq-mini">' + books.slice(0, 4).map(function (r) {
          return '<a class="card" href="' + r.url + '"><span class="cov">' +
            (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="200" height="300">' : '') + '</span>' +
            '<span class="t">' + S.mark(r.title, q) + '</span>' +
            '<span class="m">' + S.mark(r.subtitle, q) + '</span>' +
            '<span class="p">' + money(r.price) + '</span></a>';
        }).join('') + '</div></div>';
    }

    var authors = res.groups.a.filter(function (r) { return r !== top; });
    if (authors.length) {
      html += '<div class="twsq-sec"><div class="twsq-sechead"><h4>Authors</h4>' +
        '<button type="button" data-tab="a">See all ' + res.counts.a + ' &rarr;</button></div>' +
        '<div class="twsq-people">' + authors.slice(0, 3).map(function (r) {
          return '<a class="twsq-person" href="' + r.url + '">' +
            (r.img ? '<img src="' + r.img + '" alt="" loading="lazy" width="38" height="38">'
                   : '<span class="mono">' + S.esc(initials(r.title)) + '</span>') +
            '<span><span class="n">' + S.mark(r.title, q) + '</span>' +
            '<span class="m">' + S.esc(r.subtitle) + '</span></span></a>';
        }).join('') + '</div></div>';
    }

    var rest = [];
    ['w', 'r', 'g', 'c'].forEach(function (t) {
      res.groups[t].forEach(function (r) { if (r !== top) rest.push(r); });
    });
    if (rest.length) {
      html += '<div class="twsq-sec"><div class="twsq-sechead"><h4>Also on the site</h4>' +
        '<span class="c">' + rest.length + '</span></div><div class="twsq-list">' +
        rest.slice(0, 5).map(function (r) {
          return '<a class="twsq-li" href="' + r.url + '">' +
            '<span class="k ' + r.type + '">' + S.TYPES[r.type].label + '</span>' +
            '<span><span class="t">' + S.mark(r.title, q) + '</span>' +
            '<span class="m">' + S.mark(r.subtitle || '', q) + '</span></span>' +
            '<span class="go">&rarr;</span></a>';
        }).join('') + '</div></div>';
    }

    pMain.innerHTML = html;
    pAll.textContent = 'See all ' + res.total + ' result' + (res.total === 1 ? '' : 's') + ' →';
  }

  function panelRows() {
    return pMain.querySelectorAll('.twsq-top, .twsq-mini .card, .twsq-person, .twsq-li');
  }
  function moveCursor(d) {
    var rows = panelRows();
    if (!rows.length) return;
    if (cursor >= 0 && rows[cursor]) rows[cursor].classList.remove('is-cursor');
    cursor = (cursor + d + rows.length) % rows.length;
    rows[cursor].classList.add('is-cursor');
    rows[cursor].scrollIntoView({ block: 'nearest' });
  }

  function placePanel() {
    var nav = document.querySelector('.twsh nav.twsnav') || document.querySelector('nav');
    var b = nav ? nav.getBoundingClientRect().bottom : 100;
    /* The header hides itself on scroll down (assets/tws-header.js, "reveal on
       scroll up"). While it is tucked its rect sits one full height above where
       it is about to settle, so measuring it lands the panel too high. The tuck
       is exactly translateY(-100%), so adding the height back gives the
       resting position — and the bar animates back in underneath. */
    var shell = nav && nav.closest('.tws-header-section');
    if (shell && shell.classList.contains('is-tucked')) b += nav.offsetHeight;
    panel.style.top = Math.max(12, b + 10) + 'px';
  }
  function openPanel() {
    /* "/" can be pressed while the bar is tucked; ask for it back first. */
    document.dispatchEvent(new CustomEvent('tws:reveal-header'));
    placePanel();
    scrim.classList.add('is-open');
    panel.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    pInput.value = (pageInput && pageInput.value) || '';
    sync(pField, pInput);
    pMain.innerHTML = loadingHTML();
    setTimeout(function () { pInput.focus(); pInput.select(); }, 40);
    load().then(function () { panelRender(pInput.value); })
          .catch(function () { pMain.innerHTML = failHTML(pInput.value); });
  }
  function closePanel() {
    scrim.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* ══ 2. RESULTS PAGE ═══════════════════════════════════════════════════ */
  var PAGE = 24;
  var state = { q: '', tab: 'all', genre: '', fmt: '', sort: 'rel', shown: PAGE };
  var SORTS = [['rel', 'Relevance'], ['new', 'Newest first'],
               ['lo', 'Price, low to high'], ['hi', 'Price, high to low']];
  var GENRES = [['poetry', 'Poetry'], ['fiction', 'Fiction'],
                ['non-fiction', 'Essays & non-fiction'], ['children', 'Children’s']];
  var FORMATS = [['paperback', 'Paperback'], ['hardcover', 'Hardcover'], ['digital', 'Digital']];

  function applyRefine(list) {
    if (state.genre) list = list.filter(function (r) { return (' ' + r.keywords + ' ').indexOf(' ' + state.genre + ' ') >= 0; });
    if (state.fmt) list = list.filter(function (r) { return (' ' + r.keywords + ' ').indexOf(' ' + state.fmt + ' ') >= 0; });
    if (state.sort === 'new') list = list.slice().sort(function (a, b) { return (b.extra || '').localeCompare(a.extra || ''); });
    if (state.sort === 'lo') list = list.slice().sort(function (a, b) { return (a.price || 1e9) - (b.price || 1e9); });
    if (state.sort === 'hi') list = list.slice().sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
    return list;
  }

  function blockHTML(title, count, list, renderer, q, tab, wrapClass) {
    return '<div class="twsq-block"><div class="twsq-blockhead"><h3>' + title + '</h3>' +
      (tab ? '<button type="button" data-tab="' + tab + '">See all ' + count + ' &rarr;</button>'
           : '<span class="c">' + count + '</span>') +
      '</div><div class="' + wrapClass + '">' +
      list.map(function (r) { return renderer(r, q); }).join('') + '</div></div>';
  }

  function renderPage() {
    if (!resultsRoot) return;
    var q = state.q;
    var res = q.trim() && loaded ? S.query(q) : null;
    if (res && res.total) remember(q);
    var out = $('twsSearchOut');

    if (!res) {
      $('twsSearchH1').innerHTML = q.trim()
        ? 'Searching for <em>' + S.esc(q) + '</em>&hellip;'
        : 'Search the <em>whole house</em>';
      $('twsSearchNote').innerHTML = CFG.blurb || '&nbsp;';
    } else if (!res.total) {
      $('twsSearchH1').innerHTML = 'No results for <em>' + S.esc(q) + '</em>';
      $('twsSearchNote').innerHTML = res.didYouMean
        ? 'Did you mean <button type="button" data-q="' + S.esc(res.didYouMean) + '">' + S.esc(res.didYouMean) + '</button>?'
        : 'Try fewer words, or a different spelling.';
    } else {
      $('twsSearchH1').innerHTML = res.total + ' result' + (res.total === 1 ? '' : 's') +
        ' for <em>' + S.esc(q) + '</em>';
      $('twsSearchNote').innerHTML = res.partial
        ? 'No result matched every word &mdash; these match most of them.' : '&nbsp;';
    }

    var tabsBar = $('twsSearchTabsBar'), tabs = $('twsSearchTabs');
    if (!res || !res.total) { tabs.innerHTML = ''; tabsBar.hidden = true; }
    else {
      tabsBar.hidden = false;
      var items = [['all', 'Everything', res.total]].concat(S.ORDER.map(function (t) {
        return [t, S.TYPES[t].plural, res.counts[t]];
      }));
      tabs.innerHTML = items.map(function (it) {
        return '<button class="twsq-tab' + (state.tab === it[0] ? ' is-on' : '') + '" type="button" role="tab" ' +
          'aria-selected="' + (state.tab === it[0]) + '" data-tab="' + it[0] + '"' + (it[2] ? '' : ' disabled') + '>' +
          it[1] + '<span class="c">' + it[2] + '</span></button>';
      }).join('');
    }

    var showTools = res && res.total && state.tab === 'p';
    $('twsSearchTools').hidden = !showTools;
    if (showTools) {
      $('twsSearchRefine').innerHTML =
        GENRES.map(function (g) {
          return '<button class="twsq-chip' + (state.genre === g[0] ? ' is-on' : '') +
                 '" type="button" data-genre="' + g[0] + '">' + g[1] + '</button>';
        }).join('') +
        FORMATS.map(function (f) {
          return '<button class="twsq-chip' + (state.fmt === f[0] ? ' is-on' : '') +
                 '" type="button" data-fmt="' + f[0] + '">' + f[1] + '</button>';
        }).join('');
      $('twsSearchSort').textContent = SORTS.filter(function (s) { return s[0] === state.sort; })[0][1] + '  ↕';
    }

    if (!res) {
      out.innerHTML = q.trim() ? loadingHTML('Gathering the shelves&hellip;') :
        '<div class="twsq-empty"><span class="twsq-eyebrow">Start here</span>' +
        '<h3>Type a title, a name, or a <em>question</em></h3>' +
        '<p>&ldquo;How do I submit my manuscript&rdquo; finds the right page just as well as &ldquo;poetry&rdquo; finds the poetry.</p>' +
        '<div class="twsq-chips">' + POPULAR.map(function (p) {
          return '<button class="twsq-chip" type="button" data-q="' + S.esc(p) + '">' + S.esc(p) + '</button>';
        }).join('') + '</div></div>';
      $('twsSearchMore').hidden = true;
      return;
    }
    if (!res.total) {
      out.innerHTML = '<div class="twsq-empty"><span class="twsq-eyebrow">Nothing matched</span>' +
        '<h3>Let&rsquo;s try another way in</h3>' +
        '<p>Search a book title, an author&rsquo;s name, a genre, or what you want to do next.</p>' +
        '<div class="twsq-chips">' + POPULAR.map(function (p) {
          return '<button class="twsq-chip" type="button" data-q="' + S.esc(p) + '">' + S.esc(p) + '</button>';
        }).join('') +
        (CFG.contactUrl ? '<a class="twsq-chip" href="' + CFG.contactUrl + '">Contact us</a>' : '') +
        '</div></div>';
      $('twsSearchMore').hidden = true;
      return;
    }

    var html = '';
    if (state.tab === 'all') {
      if (res.counts.p) html += blockHTML('Books', res.counts.p, res.groups.p.slice(0, 10), bookCard, q, 'p', 'twsq-grid');
      if (res.counts.a) html += blockHTML('Authors', res.counts.a, res.groups.a.slice(0, 4), authorCard, q, 'a', 'twsq-authors');
      if (res.counts.w) html += blockHTML('Featured writings', res.counts.w, res.groups.w.slice(0, 6), writingTile, q, 'w', 'twsq-tiles');
      if (res.counts.r) html += blockHTML('Reading', res.counts.r, res.groups.r.slice(0, 4), longRow, q, 'r', 'twsq-rows');
      var misc = res.groups.g.concat(res.groups.c);
      if (misc.length) html += blockHTML('Pages &amp; collections', misc.length, misc.slice(0, 5), longRow, q, null, 'twsq-rows');
      $('twsSearchMore').hidden = true;
    } else {
      var list = state.tab === 'p' ? applyRefine(res.groups.p.slice()) : res.groups[state.tab].slice();
      var slice = list.slice(0, state.shown);
      var render = state.tab === 'p' ? bookCard : state.tab === 'a' ? authorCard
                 : state.tab === 'w' ? writingTile : longRow;
      var cls = state.tab === 'p' ? 'twsq-grid' : state.tab === 'a' ? 'twsq-authors'
              : state.tab === 'w' ? 'twsq-tiles' : 'twsq-rows';
      html += '<div class="twsq-block"><div class="twsq-blockhead">' +
        '<h3>' + S.TYPES[state.tab].plural + '</h3><span class="c">' + list.length +
        (list.length !== res.counts[state.tab] ? ' of ' + res.counts[state.tab] : '') + '</span></div>' +
        (slice.length
          ? '<div class="' + cls + '">' + slice.map(function (r) { return render(r, q); }).join('') + '</div>'
          : '<div class="twsq-empty"><h3>No books left after those filters</h3>' +
            '<p>Clear a filter to widen the shelf again.</p></div>') +
        '</div>';
      $('twsSearchMore').hidden = list.length <= state.shown;
      $('twsSearchMore').textContent = 'Show ' + Math.min(PAGE, list.length - state.shown) + ' more';
    }
    out.innerHTML = html;
  }

  function setQuery(q, keepTab) {
    state.q = q; state.shown = PAGE;
    if (!keepTab) { state.tab = 'all'; state.genre = ''; state.fmt = ''; }
    if (pageInput) { pageInput.value = q; sync(pageField, pageInput); }
    try {
      history.replaceState(null, '', q ? ROUTE + '?q=' + encodeURIComponent(q) : ROUTE);
    } catch (e) {}
    renderPage();
    if (!loaded && q.trim()) {
      load().then(renderPage).catch(function () {
        if (resultsRoot) $('twsSearchOut').innerHTML = failHTML(q);
      });
    }
  }

  function goToResults(q) {
    if (resultsRoot) {
      closePanel();
      setQuery(q);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      remember(q);
      location.href = ROUTE + '?q=' + encodeURIComponent(q);
    }
  }

  function sync(field, input) { if (field) field.classList.toggle('is-filled', !!input.value); }

  /* ══ WIRING ════════════════════════════════════════════════════════════ */
  var fields = [[pField, pInput]];
  if (pageField) fields.push([pageField, pageInput]);
  fields.forEach(function (pair) {
    var btn = pair[0].querySelector('[data-tws-clear]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      pair[1].value = ''; sync(pair[0], pair[1]); pair[1].focus();
      if (pair[1] === pInput) panelRender(''); else setQuery('');
    });
  });

  /* The header's two search icons keep their href to /search, so this still
     works with JS off — we only intercept the click. */
  Array.prototype.forEach.call(
    document.querySelectorAll('.ico-search, .bar-search, [data-tws-search-open]'),
    function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openPanel(); }); });

  scrim.addEventListener('click', closePanel);
  /* The only way out of search on a phone: no Esc key, and the scrim is a
     sliver beside a near-full-width panel. */
  var closeBtn = panel.querySelector('[data-tws-close]');
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  window.addEventListener('resize', function () { if (panel.classList.contains('is-open')) placePanel(); });

  var pT;
  pInput.addEventListener('input', function () {
    sync(pField, pInput);
    clearTimeout(pT);
    pT = setTimeout(function () { if (loaded) panelRender(pInput.value); }, 70);
  });
  pInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); moveCursor(1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); moveCursor(-1); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      var rows = panelRows();
      if (cursor >= 0 && rows[cursor]) { remember(pInput.value); location.href = rows[cursor].getAttribute('href'); }
      else goToResults(pInput.value);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) { closePanel(); return; }
    if (e.key === '/' && !/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName || '') && !e.target.isContentEditable) {
      e.preventDefault(); openPanel();
    }
  });

  pAll.addEventListener('click', function () { goToResults(pInput.value); });

  panel.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      e.preventDefault();
      if (resultsRoot) {
        closePanel(); setQuery(pInput.value);
        state.tab = tab.getAttribute('data-tab'); renderPage();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        remember(pInput.value);
        location.href = ROUTE + '?q=' + encodeURIComponent(pInput.value) + '&type=' + tab.getAttribute('data-tab');
      }
      return;
    }
    var q = e.target.closest('[data-q]');
    if (q) {
      pInput.value = q.getAttribute('data-q'); sync(pField, pInput);
      panelRender(pInput.value); pInput.focus();
    }
  });

  /* ---- results-page wiring (only when the page is present) --------------- */
  if (resultsRoot) {
    var gT;
    pageInput.addEventListener('input', function () {
      sync(pageField, pageInput);
      clearTimeout(gT);
      gT = setTimeout(function () { setQuery(pageInput.value); }, 160);
    });
    pageInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(gT); setQuery(pageInput.value); }
    });
    /* The field lives in a real <form action="/search">, so a no-JS submit
       still reaches Shopify's own search. Intercept it when we can do better. */
    var form = resultsRoot.querySelector('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); setQuery(pageInput.value); });

    $('twsSearchTabsBar').addEventListener('click', function (e) {
      var t = e.target.closest('[data-tab]');
      if (t && !t.disabled) {
        state.tab = t.getAttribute('data-tab'); state.shown = PAGE;
        if (state.tab !== 'p') { state.genre = ''; state.fmt = ''; }
        renderPage();
      }
    });

    resultsRoot.querySelector('.twsq-body').addEventListener('click', function (e) {
      var t = e.target.closest('[data-tab]');
      if (t) {
        state.tab = t.getAttribute('data-tab'); state.shown = PAGE; renderPage();
        $('twsSearchTabsBar').scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
      }
      var g = e.target.closest('[data-genre]');
      if (g) { var v = g.getAttribute('data-genre'); state.genre = state.genre === v ? '' : v; state.shown = PAGE; renderPage(); return; }
      var f = e.target.closest('[data-fmt]');
      if (f) { var w = f.getAttribute('data-fmt'); state.fmt = state.fmt === w ? '' : w; state.shown = PAGE; renderPage(); return; }
      var q = e.target.closest('[data-q]');
      if (q) { setQuery(q.getAttribute('data-q')); }
    });

    $('twsSearchNote').addEventListener('click', function (e) {
      var q = e.target.closest('[data-q]');
      if (q) setQuery(q.getAttribute('data-q'));
    });

    $('twsSearchSort').addEventListener('click', function () {
      var i = 0; SORTS.forEach(function (s, n) { if (s[0] === state.sort) i = n; });
      state.sort = SORTS[(i + 1) % SORTS.length][0]; state.shown = PAGE; renderPage();
    });

    $('twsSearchMore').addEventListener('click', function () { state.shown += PAGE; renderPage(); });

    /* boot from the URL Shopify landed us on */
    var params = new URLSearchParams(location.search);
    var q0 = params.get('q') || '';
    var t0 = params.get('type') || '';
    state.q = q0;
    if (pageInput) { pageInput.value = q0; sync(pageField, pageInput); }
    renderPage();
    if (q0.trim()) {
      load().then(function () {
        if (t0 && S.TYPES[t0]) state.tab = t0;
        renderPage();
      }).catch(function () { $('twsSearchOut').innerHTML = failHTML(q0); });
    }
  }
})();
